module.exports = __webpack_public_path__ + "fd0e114fde80acbc73908de430b6ed25.gif";